import { useQuotation } from '../context'
import formatPrice from '../../utils/formatPrice'

import { OnboardingTitle } from './OnboardingTitle'

import { Hint, Select } from '@olino/design-system'

const guaranteeAmounts = [1_000]

export const PricingASDGuaranteeAmountSlider = () => {
  const { quotation, updateQuotation } = useQuotation()

  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-center">
      <OnboardingTitle.H3Pricing>
        Plafond de garantie <span className="hidden md:inline-block">:</span>
        <Hint className="visible ml-1 md:hidden">
          La <span className="font-semibold">limite de garantie</span> est la somme maximum
          d'indemnisation que l'assurance vous versera en cas de sinistre.
        </Hint>
      </OnboardingTitle.H3Pricing>

      <Select
        className="min-w-[180px]"
        options={guaranteeAmounts}
        value={quotation.details.assistanceDomestique?.guaranteeAmount || 1_000}
        getOptionLabel={(value) => formatPrice(value, 0)}
        onChange={(value) =>
          updateQuotation({
            details: {
              assistanceDomestique: {
                guaranteeAmount: value,
              },
            },
          })
        }
      />

      <Hint className="hidden md:visible">
        La <span className="font-semibold">limite de garantie</span> est la somme maximum
        d'indemnisation que l'assurance vous versera en cas de sinistre.
      </Hint>
    </div>
  )
}
